import $ from "jquery";
import Swiper, {
  FreeMode,
  Manipulation,
  Navigation,
  Thumbs,
  EffectFade,
} from "swiper";
import { accessibilityOptionsMFP } from "./modal";
import { Tabs } from "./tab";
import { LinkOpener } from "./links";

// Limit for fetching thumbnails before and after.
const ID_LIMIT = 25;

// Per page limit for fetching slides async.
const PER_PAGE = 20;

let galleryThumbs;
let galleryTop;

export function setupMediaModal() {
  // Gather media ids.
  const mediaModal = document.querySelector("#mediamodal");
  const teaserImages = document.querySelectorAll(".teaser-image a");
  const navSwiperContainer = mediaModal.querySelector(
    ".mediamodal-nav .swiper-wrapper"
  );
  const mainSwiperContainer = mediaModal.querySelector(
    ".mediamodal-content .swiper-wrapper"
  );

  let mediaIds = [];

  for (const image of teaserImages) {
    const id = image.dataset.id;
    if (id) {
      mediaIds.push(id);
    }
  }

  mediaModal.dataset.ids = mediaIds;

  $(".feed-container").on("click", ".teaser a", function (e) {
    // This id will be only available in Media.
    const currentId = this.dataset.id;

    // We dont need popup. Bail.
    if (!currentId) {
      return;
    }

    e.preventDefault();

    const allIds = mediaModal.dataset.ids.split(",");
    const currentIndex = allIds.findIndex((el) => el == currentId);
    let initialIds = [];

    for (let i = currentIndex - ID_LIMIT; i <= currentIndex + ID_LIMIT; i++) {
      if (allIds[i]) {
        initialIds.push(allIds[i]);
      }
    }

    const slideIndex = initialIds.findIndex((el) => el == currentId);

    $.magnificPopup.open({
      items: {
        src: ".feed-loader",
        type: "inline",
      },
      mainClass: "mediamodal",
      modal: true,
    });

    $.post(
      LOCALIZED.ajax_url,
      {
        action: "nge_get_swiper_media_details",
        ids: initialIds,
        nonce: LOCALIZED.ajax_nonce,
        cache: false,
      },
      (result) => {
        $.magnificPopup.close();
        if (true == result.success) {
          const data = result.data;
          navSwiperContainer.innerHTML = data.thumb.join("");
          mainSwiperContainer.innerHTML = data.main.join("");

          $.magnificPopup.open({
            items: {
              src: "#mediamodal",
              type: "inline",
            },
            mainClass: "mediamodal",
            callbacks: {
              close: function () {
                navSwiperContainer.innerHTML = "";
                mainSwiperContainer.innerHTML = "";
                closeMediaModal();
              },
              open: function () {
                openMediaModal(
                  slideIndex,
                  "feed",
                  currentIndex,
                  allIds,
                  initialIds
                );
              },
            },
            ...accessibilityOptionsMFP,
          });
        } else {
          // Error in AJAX. Open link normally.
          window.location.replace($(this).attr("href"));
        }
      }
    );
  });
}

// Open media model.
export function openMediaModal(
  slideIndex,
  mode = "non-feed",
  currentIndex = null,
  allIds = null,
  initialIds = null
) {
  // Freeze body scrolling
  freezeBodyScroll();

  // Get current viewport width.
  const currentWidth = Math.max(
    document.documentElement.clientWidth || 0,
    window.innerWidth || 0
  );

  // Thumbnail slider.
  galleryThumbs = new Swiper(
    "#mediamodal .mediamodal-nav .mediamodal-nav-inner",
    {
      modules: [FreeMode, Manipulation],
      spaceBetween: 0,
      slidesPerView: 3,
      initialSlide: slideIndex,
      loop: false,
      init: false,
      freeMode: true,
      lazy: true,
      preloadImages: false,
      centeredSlides: false,
      allowTouchMove: false,
      observer: true,
      threshold: 30,
      watchSlidesVisibility: true,
      watchSlidesProgress: true,
      breakpoints: {
        450: {
          slidesPerView: 5,
        },
        510: {
          slidesPerView: 6,
        },
        575: {
          slidesPerView: 7,
        },
        715: {
          slidesPerView: 8,
        },
        850: {
          slidesPerView: 9,
        },
        960: {
          slidesPerView: 13,
        },
        1120: {
          slidesPerView: 19,
        },
      },
    }
  );

  // Main slider.
  galleryTop = new Swiper("#mediamodal .mediamodal-content", {
    modules: [EffectFade, Manipulation, Navigation, Thumbs],
    spaceBetween: 0,
    initialSlide: slideIndex,
    loop: false,
    init: false,
    allowTouchMove: false,
    observer: true,
    lazy: true,
    thumbs: {
      swiper: galleryThumbs,
      multipleActiveThumbs: false,
    },
    navigation: {
      nextEl: "#mediamodal .mediamodal-nav-next",
      prevEl: "#mediamodal .mediamodal-nav-prev",
    },
  });

  // Swiper supposedly has inbuilt support for keyboard navigation by adding the keyboard {enabled: true} property, but can't get that to work
  // As such manually handling here
  $("#mediamodal")
    .off("keydown")
    .on("keydown", (e) => {
      if (e.keyCode === 39) {
        galleryTop.slideNext();
      }
      if (e.keyCode === 37) {
        galleryTop.slidePrev();
      }
    });

  const $thumbWrapper = $("#mediamodal .mediamodal-nav .mediamodal-nav-inner");

  galleryTop.on("beforeInit", function () {
    $thumbWrapper.hide();
  });

  galleryTop.on("afterInit", function () {
    $thumbWrapper.fadeIn();
  });

  if ("non-feed" === mode) {
    galleryThumbs.init();
    galleryTop.init();

    return;
  }

  // Function to process IDs.
  const processMediaIDs = (dataList) => {
    if (0 === dataList.length) {
      return;
    }

    // Fetch first and remove it from main array.
    const first = dataList.shift();

    const req = $.post(LOCALIZED.ajax_url, {
      action: "nge_get_swiper_media_details",
      ids: first.ids,
      nonce: LOCALIZED.ajax_nonce,
      cache: false,
    });

    req.done(function (result) {
      if (true == result.success) {
        const data = result.data;

        $thumbWrapper.hide();

        if ("before" === first.mode) {
          galleryTop.prependSlide(data.main.reverse());
          galleryThumbs.prependSlide(data.thumb.reverse());
        } else {
          galleryTop.appendSlide(data.main);
          galleryThumbs.appendSlide(data.thumb);
        }

        galleryThumbs.update();
        galleryTop.update();

        // Trigger tabs for new slides.
        Tabs();

        // Open external link in new window.
        LinkOpener();
      }
    });
  };
  // End function.

  // Function to load additional thumbnails in the media modal.
  const remainingIds = allIds.filter((x) => !initialIds.includes(x));

  if (!remainingIds) {
    return;
  }

  let beforeSet = [];
  let afterSet = [];

  // Gather after IDs.
  const afterIds = allIds.filter((element, i) => {
    return i > parseInt(currentIndex + ID_LIMIT);
  });

  // Prepare set of after IDs.
  if (afterIds.length) {
    for (let i = 0; i < afterIds.length; i = i + PER_PAGE) {
      let item = {
        ids: afterIds.slice(i, i + PER_PAGE),
        mode: "after",
      };
      afterSet.push(item);
    }
  }

  // Gather before IDs.
  const beforeIds = allIds.filter((element, i) => {
    return i < parseInt(currentIndex - ID_LIMIT);
  });

  // Prepare set of before IDs.
  if (beforeIds.length) {
    beforeIds.reverse();
    for (let i = 0; i < beforeIds.length; i = i + PER_PAGE) {
      let item = {
        ids: beforeIds.slice(i, i + PER_PAGE).reverse(),
        mode: "before",
      };
      beforeSet.push(item);
    }
  }

  galleryTop.on("update", function () {
    setTimeout(function () {
      $thumbWrapper.fadeIn();
    }, 200);
  });

  galleryTop.on("reachEnd", function () {
    processMediaIDs(afterSet);
  });

  galleryTop.on("reachBeginning", function () {
    processMediaIDs(beforeSet);
  });

  galleryTop.on("observerUpdate", function () {
    Tabs();
    LinkOpener();
  });

  galleryThumbs.init();
  galleryTop.init();

  // Trigger tabs in modal.
  Tabs();

  // Open external link in new window.
  LinkOpener();
}

// Close media model.
export function closeMediaModal() {
  galleryThumbs.destroy();
  galleryTop.destroy();
  // This gets added by default when the modal is opened but doesn't get removed and prevents the loader from functioning
  const feedLoader = document.querySelector(".feed-loader");
  if (feedLoader) {
    feedLoader.classList.remove("mfp-hide");
  }

  // Enable body scrolling
  freeBodyScroll();
}

// BODY SCROLLING HANDLERS
const objectCountRef = { current: 0 }

export function freezeBodyScroll() {
  if (objectCountRef.current === 0) {  // trigger the init process when there is no other popup exist
    document.body.style.top = `-${window.scrollY}px`
    document.body.style.position = 'fixed'
  }
  objectCountRef.current += 1
}

export function freeBodyScroll() {
  objectCountRef.current -= 1
  if (objectCountRef.current === 0) {  // trigger the reset process when all the popup are closed
    const scrollY = document.body.style.top
    document.body.style.position = ''
    document.body.style.top = ''
    window.scrollTo(0, parseInt(scrollY || '0') * -1)
  }
}